import React, { useEffect, useState } from "react";
import LineItem from "./LineItem";
import TotalDue from "./TotalDue";
import MonthlyTotalDue from "./MonthlyTotalDue";

const purchase = ["purchase_for"];
const monthly = ["rent_for", "lease_for", "monthly_fee"];
function LineItems({
    equipments_data,
    addQuantity,
    removeQuantity,
    updateEquipment,
    removeEquipment,
    allEquipments,
    action,
    equipmentCount,
}) {
    return (
        <div className="cost-of-selection">

            <h5>Cost of Hardware Selections Only</h5>
            <p className="device-cat">Purchases</p>
            {equipments_data["purchase_for"] &&
                Object.keys(equipments_data["purchase_for"]).map((slug) => {
                    const equipment = equipments_data["purchase_for"][slug][0];
                    const equipments = equipments_data["purchase_for"][slug];
                    const quantity =
                        equipments_data["purchase_for"][slug].length;
                    if (quantity) {
                        return (
                            <LineItem
                                key={equipment.id}
                                id={equipment.id}
                                name={equipment.equipment_name}
                                price={equipment.purchase_for_default}
                                quantity={quantity}
                                equipment={equipment}
                                equipments={equipments}
                                addQuantity={(eqp) =>
                                    addQuantity(eqp, "purchase_for", slug)
                                }
                                removeQuantity={(eqp) =>
                                    removeQuantity(eqp, "purchase_for", slug)
                                }
                                updateEquipment={(eqp) =>
                                    updateEquipment(eqp, "purchase_for", slug)
                                }
                                removeEquipment={() =>
                                    removeEquipment("purchase_for", slug)
                                }
                                allEquipments={allEquipments}
                                action={action}
                            />
                        );
                    }
                    return null;
                })}
            <TotalDue
                title="Total Due Today"
                calculateBy={purchase}
                equipments={equipments_data}
            />
            <p className="device-cat">Monthly Costs</p>
            {equipments_data["rent_for"] &&
                Object.keys(equipments_data["rent_for"]).map((slug) => {
                    const equipment = equipments_data["rent_for"][slug][0];
                    const quantity = equipments_data["rent_for"][slug].length;
                    if (quantity) {
                        const equipments = equipments_data["rent_for"][slug];
                        return (
                            <LineItem
                                key={equipment.id}
                                id={equipment.id}
                                name={equipment.equipment_name}
                                price={equipment.rent_for_default}
                                quantity={quantity}
                                tag="rent"
                                equipment={equipment}
                                equipments={equipments}
                                addQuantity={(eqp) =>
                                    addQuantity(eqp, "rent_for", slug)
                                }
                                removeQuantity={(eqp) =>
                                    removeQuantity(eqp, "rent_for", slug)
                                }
                                updateEquipment={(eqp) =>
                                    updateEquipment(eqp, "rent_for", slug)
                                }
                                removeEquipment={() =>
                                    removeEquipment("rent_for", slug)
                                }
                                allEquipments={allEquipments}
                                action={action}
                            />
                        );
                    }
                    return null;
                })}
            {equipments_data["lease_for"] &&
                Object.keys(equipments_data["lease_for"]).map((slug) => {
                    const equipment = equipments_data["lease_for"][slug][0];
                    const quantity = equipments_data["lease_for"][slug].length;
                    if (quantity) {
                        const equipments = equipments_data["lease_for"][slug];
                        return (
                            <LineItem
                                key={equipment.id}
                                id={equipment.id}
                                name={equipment.equipment_name}
                                price={equipment.lease_for_default}
                                quantity={quantity}
                                tag="lease"
                                equipment={equipment}
                                equipments={equipments}
                                addQuantity={(eqp) =>
                                    addQuantity(eqp, "lease_for", slug)
                                }
                                removeQuantity={(eqp) =>
                                    removeQuantity(eqp, "lease_for", slug)
                                }
                                updateEquipment={(eqp) =>
                                    updateEquipment(eqp, "lease_for", slug)
                                }
                                removeEquipment={() =>
                                    removeEquipment("lease_for", slug)
                                }
                                allEquipments={allEquipments}
                                action={action}
                            />
                        );
                    }
                    return null;
                })}
            {equipments_data["monthly_fee"] &&
                Object.keys(equipments_data["monthly_fee"]).map((slug) => {
                    const equipment = equipments_data["monthly_fee"][slug][0];
                    const quantity =
                        equipments_data["monthly_fee"][slug].length;
                    if (quantity) {
                        const equipments = equipments_data["monthly_fee"][slug];
                        return (
                            <LineItem
                                key={equipment.id}
                                id={equipment.id}
                                name={equipment.equipment_name}
                                price={equipment.monthly_fee_default}
                                quantity={quantity}
                                tag="monthly"
                                equipment={equipment}
                                equipments={equipments}
                                addQuantity={(eqp) =>
                                    addQuantity(eqp, "monthly_fee", slug)
                                }
                                removeQuantity={(eqp) =>
                                    removeQuantity(eqp, "monthly_fee", slug)
                                }
                                updateEquipment={(eqp) =>
                                    updateEquipment(eqp, "monthly_fee", slug)
                                }
                                removeEquipment={() =>
                                    removeEquipment("monthly_fee", slug)
                                }
                                allEquipments={allEquipments}
                                action={action}
                            />
                        );
                    }
                    return null;
                })}
            <MonthlyTotalDue
                title="Total Due Monthly"
                calculateBy={monthly}
                equipments={equipments_data}
                equipmentCount={equipmentCount}
            />
            <p className="device-cat">TPP Hardware</p>
            {equipments_data["apply_tpp"] &&
                Object.keys(equipments_data["apply_tpp"]).map((slug) => {
                    const equipment = equipments_data["apply_tpp"][slug][0];
                    const equipments = equipments_data["apply_tpp"][slug];
                    const quantity = equipments_data["apply_tpp"][slug].length;
                    if (quantity) {
                        return (
                            <LineItem
                                key={equipment.id}
                                id={equipment.id}
                                name={equipment.equipment_name}
                                price={equipment.rent_for_default}
                                quantity={quantity}
                                apply_tpp
                                equipment={equipment}
                                equipments={equipments}
                                addQuantity={(eqp) =>
                                    addQuantity(eqp, "apply_tpp", slug)
                                }
                                removeQuantity={(eqp) =>
                                    removeQuantity(eqp, "apply_tpp", slug)
                                }
                                updateEquipment={(eqp) =>
                                    updateEquipment(eqp, "apply_tpp", slug)
                                }
                                removeEquipment={() =>
                                    removeEquipment("apply_tpp", slug)
                                }
                                allEquipments={allEquipments}
                                action={action}
                            />
                        );
                    }
                    return null;
                })}
        </div>
    );
}

export default LineItems;
